function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.977 22H2.83V8.647h4.147V22zM4.9 6.826C3.575 6.826 2.5 5.727 2.5 4.402a2.401 2.401 0 014.803 0c0 1.325-1.076 2.424-2.402 2.424zM22.496 22h-4.138v-6.5c0-1.55-.031-3.536-2.156-3.536-2.156 0-2.486 1.683-2.486 3.424V22H9.574V8.647h3.977v1.822h.058c.553-1.05 1.906-2.157 3.923-2.157 4.197 0 4.968 2.764 4.968 6.353V22h-.005z",
  fill: "#fff"
});
function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default SvgLinkedin;